


















import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { PolylineItem } from "../../../../domain/document/items";
import { Point } from "../../../../domain/drawing";
import {
  DraggableLineDrawableObjectMixin
} from "./mixins";
import RectangleDragHandles from "../../../dragging/RectangleDragHandles.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    RectangleDragHandles,
  }
})
export default class PolylineObject extends Mixins(
  DraggableLineDrawableObjectMixin
) implements IKeyboardEventHandleable {
  editingSource: PolylineItem;

  get points(): string {
    const pointsAsStrings = Enumerable.from(this.editingSource.points)
      .select(p => {
        const adjusted = p
          .subtract(this.absoluteGeometry.rectangle.topLeft);
        return adjusted.x + " " + adjusted.y;
      })
      .toArray();
    return pointsAsStrings.join(" ");
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.points = Enumerable.from(s.points as Point[])
        .select(p => p.add(moveOffset))
        .toArray());
      return true;
    }
    return false;
  }
}
